import { useEffect, useState } from 'react';

import { useMatches } from 'react-router-dom';

import { IRouteData, RouteId } from '@/types';
import { flattenedPfbRoutes, pfbRoutes } from '@/router/pfbRoutes';
import { getMatchedRoute } from '@/utils/Router.utils';

type RouteMeta = {
	pathname: string;
	data: IRouteData & { pageName: RouteId; isAuthenticated: boolean };
};

export const usePFBRoutes = () => {
	const routeMatches = useMatches();
	const { id, pathname } = routeMatches[routeMatches.length - 1];

	const { isAuthenticated = false, routeData = {} } =
		flattenedPfbRoutes[id as RouteId];
	const [routeMeta, setRouteMeta] = useState<RouteMeta>({
		pathname,
		data: { pageName: id as RouteId, isAuthenticated },
	});

	useEffect(() => {
		setRouteMeta({
			pathname,
			data: { pageName: id as RouteId, isAuthenticated, ...routeData },
		});
	}, [id, pathname]);

	return routeMeta;
};

/**
 *
 * @param [path] - path to fetch data for. Returns for current path if `path` not provided
 */
usePFBRoutes.getData = (path?: string): RouteMeta | null => {
	const matchedRoute = getMatchedRoute(pfbRoutes, path);
	if (matchedRoute) {
		const { pathname, route } = matchedRoute;
		return {
			pathname: pathname,
			data: {
				pageName: route.id,
				isAuthenticated: !!route.isAuthenticated,
				...(route.routeData ?? {}),
			},
		};
	}
	return null;
};
